import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Divider, Button, Popup, Checkbox } from "semantic-ui-react";
import axios from 'axios'
import Table from "../component/Table";
import Swal from 'sweetalert2'
import Pesan from "../component/Pesan";

const PopupHome = () => {
    const navigate = useNavigate()
    const [popup, setPopup] = useState([])
    const [showAlert, setShowAlert] = useState(false)

    const handleChangeEnable = (e, value) => {
        updateState(value.id_popup)
    }


    const deletePopup = (id) => {
        const param = { id_popup: id }

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3b5998',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios({
                    method: "POST",
                    url: `${global.SRV}api_hoops_cms/controler/popup.php/?index=4`,
                    headers: { 'Content-Type': 'text/plain' },
                    data: param
                })
                    .then(res => {
                        if (res.data.state === 200) {
                            getPopup()
                            setShowAlert(true)
                        }
                    })
            }
        })
    }

    const updateState = (id) => {
        let param = { id_popup: id }

        axios({
            method: "POST",
            url: `${global.SRV}api_hoops_cms/controler/popup.php/?index=3`,
            headers: { 'Content-Type': 'text/plain' },
            data: param
        })
            .then(res => {
                if (res.data.state === 200) {
                    getPopup()
                }
            })
    }

const columns = useMemo(() => [
    {
        Header: "ID",
        accessor: "id_popup",
        Cell: ({ cell }) => (
            <div style={{   textAlign: 'center', 
                            width: '100%' 
                        }}>
                {cell.value}
            </div>
        )
    },
    {
        Header: "Information",
        accessor: "information",
        Cell: ({ cell }) => (
            <div
                style={{
                    minWidth: '100%',
                    maxWidth: '250px',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    lineHeight: '1.4'
                }}
            >
                {cell.value}
            </div>
        )
    },
    {
        Header: "CTA",
        accessor: "url",
        Cell: ({ cell }) => (
            <div style={{   //textAlign: 'center', 
                            width: '100%' 
                        }}>
                {cell.value !== ''
                    ? <p>Yes</p>
                    : <p>No</p>
                }
            </div>
        )
    },
    {
        Header: "Image",
        accessor: "image",
        Cell: ({ cell }) => (
            <div style={{   //textAlign: 'center', 
                            width: '100%' 
                        }}>
                {cell.value !== ''
                    ? <Image src={cell.value} width={50} height={50} />
                    : <Image src="https://via.placeholder.com/500x400.png" width={50} height={50} />
                }
            </div>
        )
    },
    {
        Header: "Enabled",
        accessor: "is_active",
        Cell: ({ cell }) => (
            <div style={{   //textAlign: 'center', 
                            width: '100%' 
                        }}>
                {/* 
                <Checkbox
                    toggle
                    defaultChecked={cell.value === 'Y'}
                    style={{ transform: 'scale(.7)' }}
                    onChange={(e) => handleChangeEnable(e, cell.row.values)}
                />
                */}
                <Checkbox
                    toggle
                    checked={cell.value === 'Y'}
                    style={{ transform: 'scale(.7)' }}
                    onChange={(e) => handleChangeEnable(e, cell.row.values)}
                />
            </div>
        )
    },
    {
        Header: "Action",
        id: "action",
        Cell: ({ cell }) => (
            <div style={{   //textAlign: 'center', 
                            width: '100%' 
                        }}>
                <Button.Group size="mini" basic>
                    <Popup content="Edit" trigger={
                        <Button 
                            icon="edit" 
                            size="mini" 
                            onClick={() => navigate('/popup_home_edit', { state: cell.row.original })} 
                        />} 
                    />
                    <Popup content="Delete" trigger={
                        <Button 
                            icon="eraser" 
                            size="mini" 
                            onClick={() => deletePopup(cell.row.values.id_popup)} 
                        />} 
                    />
                </Button.Group>
            </div>
        )
    }
], [])

    const getPopup = async () => {
        await axios.get(`${global.SRV}api_hoops_cms/controler/popup.php/?index=1`)
            .then(res => {
                if (res.data.state === 200) {
                    setPopup(res.data.data)
                }
            })
    }

    useEffect(() => {
        getPopup()
    }, [])

    return (
        <Fragment>
            <Container fluid>
                <Row className="mt-1 mb-3">
                    <div className="text-facebook h3 mb-0">Popup Home Item</div>
                    <div className="text-muted">This Popup will be shown when the website is visited.</div>
                </Row>
                <Divider />
                <Pesan variant="success" setShowAlert={setShowAlert} show={showAlert} content="Success delete selected item" header="Item deleted" />

                <Row className="d-flex justify-content-center mb-3 mt-3">
                    <Col xl={12} lg={12} md={12} sm={12} className="d-flex justify-content-start mb-3">
                        <Button content="New Popup Item" color="facebook" onClick={() => navigate('/popup_home_add')} />
                    </Col>
                    <Col xl={12} lg={12} md={12} sm={12}>
                        <Table columns={columns} data={popup} pageRow={10} />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default PopupHome